import { useEffect } from 'react'
import './modal.scss'
// redux
import { useSelector } from 'react-redux'
// hook
import useUIActions from '../../../hooks/useUIActions'
import Image from '../Image/image'
// component
import Button from '../button/button'
import Portal from '../portal/portal'
// icons
import { CloseIcon } from '../icons'

const Modal = props => {
	const {
		close = true,
		onClose,
		title,
		imagen,
		alt,
		description,
		descClasses,
		classes = '',
		children,
		buttons,
		imageFit = 'contain',
		notification = false
	} = props

	// hooks
	const { handleCloseModal, handleShowCloseIconModal } = useUIActions()
	const { showIconCloseModal } = useSelector(state => state.elementsUI)

	const showCloseIconModal = showIconCloseModal && close

	const handleClose = () => {
		onClose && onClose()
		handleCloseModal()
	}

	/* A cleanup function that is called when the component is unmounted to return it to its initial state by displaying the modal icon. */
	useEffect(() => {
		// true is the default value
		return () => handleShowCloseIconModal(true)
	}, [])

	return (
		<Portal id='modal'>
			<div className={`a-modal ${classes || ''} ${notification ? 'notification' : ''}`}>
				<div className='a-modal__curtain' onClick={() => showCloseIconModal && handleClose()} />

				<div className='a-modal__container' onClick={e => e.stopPropagation()}>
					{showCloseIconModal && (
						<div
							className={`a-modal-close-container ${notification && 'white'}`}
							onClick={() => handleClose()}
						>
							<CloseIcon color='#ee2b7b' />
						</div>
					)}

					{imagen &&
						(notification ? (
							<div className='notification__img'>
								<Image classes='a-modal-image' src={imagen} alt={alt} fit={imageFit} width='79' />
							</div>
						) : (
							<Image classes='a-modal-image' src={imagen} alt={alt} fit={imageFit} />
						))}

					{title && <h2 className='a-modal-title'> {title} </h2>}

					{(description || children) && (
						<div className='a-modal-body'>
							{description && (
								<p className={`a-modal-body-description ${descClasses || ''}`}>{description}</p>
							)}

							{children && <div> {children} </div>}

							{buttons && buttons.length && (
								<div className='a-modal-body-buttons'>
									{buttons.map(button => (
										<Button
											key={button.title}
											title={button.title}
											classes={button.classes}
											onClick={button.onClick}
										/>
									))}
								</div>
							)}
						</div>
					)}
				</div>
			</div>
		</Portal>
	)
}

export default Modal
